import sidebarItems from './vx-sidebar/sidebarItems';

const submenu = sidebarItems
    .filter(item => item.submenu && !!item.submenu.length)
    .flatMap(item => item.submenu.map(s => {
        s.roles = s.roles || item.roles || [];
        return s;
    }));

export default {
    actionIcon: 'StarIcon',
    highlightColor: 'warning',
    data: sidebarItems.concat(submenu).filter(item => item.icon).map((item, index) => {
        item.index = index;
        item.labelIcon = item.icon;
        item.label = item.name;
        item.highlightAction = false;
        return item;
    }),
}
